import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { StationFormData, stationSchema } from "../schemas/station";
import { FormField } from "./ui/FormField";
import { SelectField } from "./ui/SelectField";
import { Button } from "./ui/Button";

interface StationFormProps {
  initialData?: StationFormData;
  onSubmit: (data: StationFormData) => Promise<void>;
  isLoading: boolean;
  isSuccess: boolean;
  isAddNew?: boolean;
}

const currencyOptions = [
  { value: "USD", label: "USD ($)" },
  { value: "EUR", label: "EUR (€)" },
];

export function StationForm({
  initialData,
  onSubmit,
  isLoading,
  isSuccess,
  isAddNew = false,
}: StationFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<StationFormData>({
    resolver: zodResolver(stationSchema),
    defaultValues: initialData,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      <div>
        <label
          htmlFor={"id"}
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          Id: <span className="font-semibold">{initialData?.id || ""}</span>
        </label>
      </div>
      <FormField
        label="Station Name"
        name="name"
        placeholder="Enter station name"
        error={errors.name?.message}
        register={register}
      />

      <FormField
        label="Connector ID"
        name="connectorId"
        placeholder="Enter connector ID: 1, 2, 3, 4"
        error={errors.connectorId?.message}
        register={register}
      />

      <FormField
        label="Payment ID"
        name="paymentId"
        placeholder="Enter payment ID"
        error={errors.paymentId?.message}
        register={register}
      />

      <FormField
        label="Price per KWh"
        name="pricePerKWh"
        placeholder="Enter price per kWh"
        error={errors.pricePerKWh?.message}
        register={register}
      />

      <SelectField
        label="Currency"
        name="currency"
        error={errors.currency?.message}
        register={register}
        options={currencyOptions}
      />

      <Button
        type="submit"
        disabled={isLoading}
        isLoading={isLoading}
        isSuccess={isSuccess}
      >
        {isAddNew
          ? "Add Station"
          : initialData
          ? "Update Station"
          : "Add Station"}
      </Button>
    </form>
  );
}
